/*
 * Public API Surface of materials
 */

export * from './materials.module';
